import React, { useState, useEffect, useRef, useCallback } from "react";
import { useNavigate, useLocation } from "react-router-dom";

import {
  Box,
  Flex,
  Text,
  VStack,
  HStack,
  Button,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Input,
  IconButton,
  Select,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalCloseButton,
  FormControl,
  FormLabel,
  useDisclosure,
  useColorMode,
  useColorModeValue,
  AlertDialogOverlay,
  AlertDialog,
  AlertDialogContent,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  Avatar,
  Tag,
  Image,
  Badge,
  InputGroup,
  InputLeftElement,
} from "@chakra-ui/react";
import {
  FaUsers,
  FaProjectDiagram,
  FaEdit,
  FaTrash,
  FaArrowLeft,
  FaArrowRight,
  FaSun,
  FaMoon,
  FaTasks,
  FaUserPlus,
  FaChartBar,
  FaClipboardList,
  FaEnvelope,
  FaPhone,
  FaUser,
  FaPlusCircle,
  FaSearch,
} from "react-icons/fa";
import {
  FiActivity,
  FiShield,
  FiServer,
  FiSearch,
  FiDownload,
  FiRefreshCw,
  FiPrinter,
  FiDatabase,
} from "react-icons/fi";
import { HiOutlineClipboardList } from "react-icons/hi";
import { db, auth, rtdb } from "./firebase/firebase";
import { logToSystem } from "./utils/systemLogging";
import {
  collection,
  getDocs,
  doc,
  getDoc,
  addDoc,
  updateDoc,
  deleteDoc,
  query,
  where,
  writeBatch,
  setDoc,
  serverTimestamp,
  onSnapshot,
  arrayUnion,
  arrayRemove,
  deleteField,
} from "firebase/firestore";
import { showToast } from "./utils/toastUtils";
import { MdAdd as _MdAdd } from "react-icons/md";
import AssignProjectsModal from "./components/AssignProjectModal";
import Sidebar from "./components/Sidebar";
import AddUserModal from "./components/AdduserModal";

import axios from "axios";

import {
  browserSessionPersistence,
  createUserWithEmailAndPassword,
  deleteUser,
  setPersistence,
  signOut,
} from "firebase/auth";
import { useAuth } from "./hooks/useAuth";
import { useSubscription } from "./hooks/useSubscription";
import LogoutComponent from "./pages/LogoutComponent";
import ProfileMenu from "./pages/ProfileMenu";
import DeleteUser from "./pages/DeleteUser";
import GanttMain from "./pages/Gantt/GanttMain";
import { FiBarChart2, FiTrendingUp, FiUserCheck } from "react-icons/fi";
import PerformanceMain from "./pages/Performance/PerformanceMain";
import AssignedTasksPopover from "./pages/AssignedTasksPopover";
import UserPerformance from "./pages/Performance/userPerformace/UserPerformance";
import ProjectPerformance from "./pages/Performance/projectPerformance/ProjectPerformance";
import KpiMetricMain from "./pages/KPI/KpiMetricMain";
import UserTable from "./components/UserTable";
import ProjectForm from "./components/ProjectForm";
import ProjectTable from "./components/ProjectTable";
import { BellIcon, SearchIcon } from "@chakra-ui/icons";
import NotificationMain from "./pages/Notifications/NotificationMain";
import SentimentAnalysis from "./pages/SentiMent/SentimentAnalysis";
import BurnOutAnalysis from "./pages/BurnOut/BurnoutAnalysisMain";
import { keyframes } from "@emotion/react";
import { UserIcon, Zap } from "lucide-react";
import EditProjectForm from "./components/EditProjectForm";
import "./index.css";
import CheckInMain from "./components/CheckInCheckOut/CheckInMain";
import TimeSheetApprovalPage from "./pages/TimeSheetApprovalPage";
import LeaveApprovalPage from "./pages/LeaveApprovalPage";
import ApprovalsPage from "./pages/ApprovalsPage";
import CheckInAlert from "./pages/CheckInAlert";
import { getThemeClasses } from "./utils/themeUtils";
import { IconWrapper } from "./components/IconWrapper";
import CalendarPage from "./components/Calendar/CalendarPage";
import type { TabType } from "./components/CheckInCheckOut/CheckInMain";
import ManagerBooking from "./components/Booking/ManagerBooking";
import UserBooking from "./components/Booking/UserBooking";
import WorkGroup from "./pages/Configuration/WorkGroup";
import Departments from "./pages/Configuration/DepartmentsMain";
import OverviewMain from "./pages/OverviewPage";
import SystemLogs from "./pages/Monitoring/SystemLogs";
import LeaveManagement from "./pages/Performance/TimesheetAnalysis/LeaveManagement";
import TeamChatsMain from "./pages/Chats/TeamChatsMain";
import MyChatsMain from "./pages/Chats/MyChatsMain";
import Help from "./pages/Helper/Help";
import SystemSettings from "./pages/Configuration/SystemSettings";
import {
  getProjectPermissions,
  getTimesheetPermissions,
  getProjectScopeAccess,
  canSeeProject,
} from "./utils/permissions";
import ProjectAccessModal from "./components/ProjectAccessModal";
import {
  fetchUserProjectAccess,
  removeProjectFromAllAccess,
  ProjectAccessMap,
} from "./utils/projectAccess";

const MdAdd = _MdAdd as unknown as React.ComponentType<any>;

interface ChannelInput {
  id: string; // existing channel doc ID, or empty for brand-new
  name: string; // the display name
}
// Define types for Users and Projects
type User = {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  role: string;
  employeeCode?: string; // New field
  department?: string; // New field
  assignedChannels?: Record<string, string[]>;
  assignedProjects?: string[];
  /** projectId → per-project role (see utils/projectAccess.ts). */
  projectAccess?: ProjectAccessMap;
  assignedTasks?: {
    id: string;
    name: string;
    taskId: string;
    channelId: string;
    projectId: string;
  }[];
  organizationId: string;
  joiningDate?: string;
  permissions?: "Admin" | "Editor" | "Viewer";
  approvalStatus?: "Yes" | "No";
  workGroupRoleId?: string;
  address1?: string;
  address2?: string;
  isOrgAdmin?: boolean;
};

type Project = {
  id: string;
  name: string;
  description?: string;
  channels: string[];
  channelIds?: string[];
  assignedUsers?: string[];
  status?: string;
  createdBy?: string;
};

type Role = {
  id: string;
  name: string;
  permission: "Admin" | "Editor" | "Viewer";
  approvalStatus?: "Yes" | "No";
  createdAt?: any;
  createdBy?: string;
};

const backendUrl = "https://api-xk2q5lbbua-uc.a.run.app";

const TAB_TO_SLUG: Record<TabType, string> = {
  "Users": "users",
  "Projects": "projects",
  "Tasks": "tasks",
  "TimeSheets": "timesheets",
  "Progress": "progress",
  "KPI-Metric": "kpi-metric",
  "Notifications": "notifications",
  "Sentiment": "sentiment",
  "Burn-Out": "burn-out",
  "Alert": "calendar-alert",
  "Calendar": "calendar",
  "TimeSheet Approval": "timesheet-approval",
  "Leave Approval": "leave-approval",
  "Approvals": "approvals",
  "profile": "profile",
  "LogPanel": "employee-logs",
  "ManagerBooking": "manager-booking",
  "SeatBooking": "seat-booking",
  "WorkGroup": "work-group",
  "Overview": "overview",
  "Departments": "departments",
  "Leave Management": "leave-management",
  "Team Chats": "team-chats",
  "My Chats": "my-chats",
  "SystemLogs": "system-logs",
  "Help": "help",
  "Check-Ins": "check-ins",
  "System Settings": "system-settings",
};

const SLUG_TO_TAB: Record<string, TabType> = Object.fromEntries(
  Object.entries(TAB_TO_SLUG).map(([tab, slug]) => [slug, tab as TabType])
);

const ADMIN_TABS = new Set<TabType>([
  "ManagerBooking", "Sentiment", "Burn-Out", "Alert",
  "Overview", "Approvals", "SystemLogs", "WorkGroup", "Departments",
  "Leave Management", "System Settings", "TimeSheet Approval", "Leave Approval",
]);

function parseModuleFromPath(pathname: string): { tab: TabType | null; isAdmin: boolean } {
  const parts = pathname.split("/").filter(Boolean);
  const orgIndex = parts.indexOf("organization");
  if (orgIndex === -1 || parts.length <= orgIndex + 2) {
    return { tab: null, isAdmin: false };
  }
  const viewSegment = parts[orgIndex + 2];
  if (viewSegment === "admin") {
    const moduleSlug = parts[orgIndex + 3];
    return { tab: moduleSlug ? (SLUG_TO_TAB[moduleSlug] || null) : null, isAdmin: true };
  }
  if (viewSegment === "projects") {
    const moduleSlug = parts[orgIndex + 3];
    return { tab: moduleSlug ? (SLUG_TO_TAB[moduleSlug] || null) : null, isAdmin: false };
  }
  const tab = SLUG_TO_TAB[viewSegment] || null;
  return { tab, isAdmin: false };
}

const COMMON_TABS = new Set<TabType>(["LogPanel", "profile", "Notifications"]);

const Dashboard: React.FC = () => {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [currentUser, setCurrentUser] = useState<User | null>(null);
  const [channelInputs, setChannelInputs] = useState<string[]>([]);
  const [isSidebarOpen, setSidebarOpen] = useState(true);

  const getInitialTab = (): TabType => {
    const { tab } = parseModuleFromPath(location.pathname);
    return tab || "Users";
  };

  const getInitialIsAdminView = (): boolean => {
    const { isAdmin } = parseModuleFromPath(location.pathname);
    return isAdmin;
  };

  const [activeTab, setActiveTabState] = useState<TabType>(getInitialTab);
  const [isAdminView, setIsAdminViewState] = useState<boolean>(getInitialIsAdminView);
  const [orgName, setOrgName] = useState<string>(() => {
    return localStorage.getItem("orgName") || "";
  });
  const [searchTerm, setSearchTerm] = useState("");
  const [isLoading, setisLoading] = useState(false);
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const [users, setUsers] = useState<User[]>([]);
  const [roles, setRoles] = useState<Role[]>([]);
  const [projects, setProjects] = useState<Project[]>([]);
  const [newUser, setNewUser] = useState<Omit<User, "id">>({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    role: "",
    organizationId: "",
    joiningDate: "",
    address1: "",
    address2: "",
  });
  const [newProject, setNewProject] = useState<Omit<Project, "id">>({
    name: "",
    channels: [],
  });
  const [newChannel, setNewChannel] = useState("");
  const [editingUser, setEditingUser] = useState<User | null>(null);
  const [selectedProjectId, setSelectedProjectId] = useState<string | null>(
    null
  );
  const [selectedUserId, setSelectedUserId] = useState<string | null>(null);
  const [organizationId, setOrganizationId] = useState<string>("");
  const [orgAdminId, setOrgAdminId] = useState<string>("");
  const { subscriptionStatus, hasAccess, loading: subscriptionLoading } = useSubscription(organizationId);

  const navigateToTab = useCallback((tab: TabType) => {
    const slug = TAB_TO_SLUG[tab];
    if (!slug || !organizationId) return;
    const basePath = `/organization/${organizationId}`;
    if (COMMON_TABS.has(tab)) {
      navigate(`${basePath}/${slug}`, { replace: true });
    } else if (ADMIN_TABS.has(tab)) {
      navigate(`${basePath}/admin/${slug}`, { replace: true });
    } else {
      navigate(`${basePath}/projects/${slug}`, { replace: true });
    }
  }, [navigate, organizationId]);

  const handleSetActiveTab = useCallback((tab: TabType | ((prev: TabType) => TabType)) => {
    if (typeof tab === "function") {
      setActiveTabState((prev) => {
        const next = tab(prev);
        navigateToTab(next);
        return next;
      });
    } else {
      setActiveTabState(tab);
      navigateToTab(tab);
    }
  }, [navigateToTab]);

  const handleSetIsAdminView = useCallback((view: boolean | ((prev: boolean) => boolean)) => {
    if (typeof view === "function") {
      setIsAdminViewState(view);
    } else {
      setIsAdminViewState(view);
    }
  }, []);
  const [editingProject, setEditingProject] = useState<Project | null>(null); // Track project being edited
  const [editProjectName, setEditProjectName] = useState(""); // Track edited name
  const [editChannelInputs, setEditChannelInputs] = useState<ChannelInput[]>(
    []
  ); // Track edited channels
  const [selectedProjects, setSelectedProjects] = useState<string[]>([]);
  const [selectedProject, setSelectedProject] = useState<string | null>(null);
  const [showProjectForm, setShowProjectForm] = useState(false);
  const cancelRef = useRef<HTMLButtonElement>(null);
  const [unreadNotifications, setUnreadNotifications] = useState<number>(0);
  const [showCalendarDetails, setShowCalendarDetails] =
    useState<boolean>(false);

  const [isProjectSaving, setIsProjectSaving] = useState(false);
  const [isProjectUpdating, setIsProjectUpdating] = useState(false);
  const [isUserSaving, setIsUserSaving] = useState(false);

  const [filteredUsers, setFilteredUsers] = useState(users);
  const [filteredProjects, setFilteredProjects] = useState(projects);
  // Track all pending entries grouped by user
  const [entriesByUser, setEntriesByUser] = useState<Record<string, any[]>>({});

  const {
    isOpen: isAssignProjectsOpen,
    onOpen: onAssignProjectsOpen,
    onClose: onAssignProjectsClose,
  } = useDisclosure();
  const [selectedUser, setSelectedUser] = useState<User | null>(null);

  const {
    isOpen: isProjectAccessOpen,
    onOpen: onProjectAccessOpen,
    onClose: onProjectAccessClose,
  } = useDisclosure();
  const [accessProject, setAccessProject] = useState<any | null>(null);

  const handleOpenProjectAccess = (project: any) => {
    // Admins always get access; editors need a project-scoped grant to manage a specific project
    const isGlobalAdmin = isOrgAdmin || userPermissions?.toLowerCase() === "admin";
    if (!isGlobalAdmin) {
      const accessMap = currentUser?.projectAccess || {};
      if (!accessMap[project.id]) {
        showToast({
          title: "Access Restricted",
          description: `You don't have access to manage roles for "${project.name}". Please contact an admin to get project access.`,
          status: "warning",
          duration: 4000,
          isClosable: true,
          position: "bottom",
        });
        return;
      }
    }
    setAccessProject(project);
    onProjectAccessOpen();
  };

  /**
   * Re-read the signed-in user's own project roles after an access change, so
   * an admin editing their own row sees the effect without a page reload.
   */
  const refreshCurrentUserProjectAccess = async () => {
    const userId = auth.currentUser?.uid;
    const orgId = currentUser?.organizationId;
    if (!userId || !orgId) return;
    const projectAccess: ProjectAccessMap = await fetchUserProjectAccess(
      orgId,
      userId
    );
    setCurrentUser((prev: any) =>
      prev ? { ...prev, projectAccess } : prev
    );
  };

  const userPermissions = currentUser?.permissions;
  const userRole = currentUser?.role?.toLowerCase();
  const hasApprovalStatus = (currentUser?.approvalStatus || "").toLowerCase() === "yes";

  // Org admin check - based on organization.admin field
  const isOrgAdmin = orgAdminId !== "" && currentUser?.id === orgAdminId;

  // Permission-based flags - org admin gets full access, others based on permissions field
  const canViewAdminModules = isOrgAdmin || userPermissions?.toLowerCase() === "admin";
  const canViewManagerModules = isOrgAdmin || userPermissions?.toLowerCase() === "admin" || userPermissions?.toLowerCase() === "editor";

  const hasAdminActionAccess = isOrgAdmin || userPermissions?.toLowerCase() === "admin";
  const hasManagerActionAccess = isOrgAdmin || userPermissions?.toLowerCase() === "admin" || userPermissions?.toLowerCase() === "editor";

  const isEditor = userPermissions?.toLowerCase() === "editor";
  const isViewer = userPermissions?.toLowerCase() === "viewer";
  // System Settings is the only thing this gates. It used to be org-owner-only,
  // which locked out admins who hold the permission without owning the org —
  // SystemSettings itself already accepts either (role or permissions "admin").
  const canViewSystemSettings = canViewAdminModules;

  // Centralized project permission flags (mirrors getTaskPermissions)
  const projectPerms = React.useMemo(
    () => getProjectPermissions(currentUser),
    [currentUser]
  );
  const {
    canCreate: canCreateProjectBase,
    canViewAll: canViewAllProjectsBase,
  } = projectPerms;

  // Org admin gets full project permissions
  const canCreateProject = canCreateProjectBase || isOrgAdmin;
  const canAssignProjects = projectPerms.canAssign || isOrgAdmin;
  const canViewAllProjects = canViewAllProjectsBase || isOrgAdmin;
  // Editing can also come from a per-project admin/editor grant. Deleting never
  // can — project-scoped access grants no delete rights anywhere in the app.
  const canEditProject = (project: any) =>
    isOrgAdmin ||
    projectPerms.canEdit(project) ||
    getProjectScopeAccess(currentUser, project?.id).canEditProject;
  const canDeleteProject = (project: any) => isOrgAdmin || projectPerms.canDelete(project);

  /** Admins and editors can see the Access column; editors are gated per-project below. */
  const canManageProjectAccess = isOrgAdmin || userPermissions?.toLowerCase() === "admin" || userPermissions?.toLowerCase() === "editor";

  // Centralized timesheet permission flags
  const timesheetPerms = React.useMemo(
    () => getTimesheetPermissions(currentUser),
    [currentUser]
  );
  const {
    canCreate: canCreateTimesheet,
    canEdit: canEditTimesheet,
    canDelete: canDeleteTimesheet,
    canApprove: canApproveTimesheetBase,
    canViewAll: canViewAllTimesheets,
  } = timesheetPerms;

  // Users with manager role OR approvalStatus "Yes" can approve timesheets
  const canApproveTimesheet = canApproveTimesheetBase || hasApprovalStatus || userRole === "manager" || userRole === "managingdirector";

  const {
    isOpen: isUserModalOpen,
    onOpen: onUserModalOpen,
    onClose: onUserModalClose,
  } = useDisclosure();

  const {
    isOpen: isProjectModalOpen,
    onOpen: onProjectModalOpen,
    onClose: onProjectModalClose,
  } = useDisclosure();

  const {
    isOpen: isAddProjectModalOpen,
    onOpen: onAddProjectModalOpen,
    onClose: onAddProjectModalClose,
  } = useDisclosure();

  const {
    isOpen: isDeleteModalOpen,
    onOpen: onDeleteModalOpen,
    onClose: onDeleteModalClose,
  } = useDisclosure();

  const confirmDelete = (projectId: string) => {
    setSelectedProject(projectId);
    onDeleteModalOpen();
  };

  const handleConfirmDelete = () => {
    if (selectedProject) {
      handleDeleteProject(selectedProject); // Call the delete function
      setSelectedProject(null);
      onDeleteModalClose();
    }
  };
  const { toggleColorMode } = useColorMode();
  const chakraColorMode = useColorModeValue("light", "dark");
  const isDark = chakraColorMode === "dark";
  const theme = getThemeClasses(isDark);
  const bgGradient = useColorModeValue(
    "linear(to-br, white, white)",
    "linear(to-br, #0B0B0F, gray.800)"
  );
  const textColor = useColorModeValue("#212121", "white");
  const cardBg = useColorModeValue("white", "#1A1C1F");

  const findOrganizationId = async (
    db: any,
    currentUserId: string
  ): Promise<string | null> => {
    try {
      const orgSnapshot = await getDocs(collection(db, "organization"));
      let organizationId = null;

      for (const orgDoc of orgSnapshot.docs) {
        const orgData = orgDoc.data();
        const member = orgData.members?.find(
          (m: any) => m.id === currentUserId
        );

        if (member) {
          organizationId = orgDoc.id;
          break;
        }
      }

      if (!organizationId) {
        showToast({
          title: "Error",
          description: "Organization not found for the current user.",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      }
      return organizationId;
    } catch (error) {
      console.error("Error finding organization ID:", error);
      showToast({
        title: "Error",
        description: "Failed to fetch organization data. Please try again.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      return null;
    }
  };

  const fetchData = async () => {
    setisLoading(true);
    try {
      // Get the current authenticated user's ID
      const userId = auth.currentUser?.uid;
      if (!userId) {
        console.error("No authenticated user found.");
        return;
      }

      // Fetch user data from the `users` collection
      const userDoc = await getDoc(doc(db, "users", userId));
      if (!userDoc.exists()) {
        console.error("User not found in the users collection.");
        return;
      }

      const userData = userDoc.data();
      const organizationId = userData.organizationId; // Extract organization ID from user data

      if (!organizationId) {
        console.error("No organizationId found for the user.");
        return;
      }

      setCurrentUser({
        id: userId,
        firstName: userData.firstName,
        lastName: userData.lastName,
        email: userData.email,
        phone: userData.phone,
        role: userData.role,
        assignedProjects: userData.assignedProjects,
        assignedChannels: userData.assignedChannels,
        organizationId: userData.organizationId,
        permissions: userData.permissions,
        approvalStatus: userData.approvalStatus,
        address1: userData.address1,
        address2: userData.address2,
      });

      setOrganizationId(organizationId);

      // Fetch the organization data for the user's organizationId
      const orgRef = doc(db, "organization", organizationId);
      const orgDoc = await getDoc(orgRef);

      if (!orgDoc.exists()) {
        console.error("Organization not found for the user's organizationId.");
        return;
      }

      const orgData = orgDoc.data();

      setOrgAdminId(orgData.admin || "");

      const fetchedOrgName = orgData.name || "";
      setOrgName(fetchedOrgName);
      localStorage.setItem("orgName", fetchedOrgName);
      const members = orgData.members || [];

      // Find the authenticated user inside the members array
      const foundUser = members.find((member: any) => member.id === userId);

      if (!foundUser) {
        console.error("User not found in the organization members list.");
        return;
      }

      // Per-project roles for this user — one document read, independent of how
      // many projects the organization has (see utils/projectAccess.ts).
      const projectAccess = await fetchUserProjectAccess(organizationId, userId);

      // ✅ Set `currentUser` from the `members` list
      const isOrgAdminNow = !!(orgData.admin && userId === orgData.admin);
      setCurrentUser({
        projectAccess,
        id: foundUser.id,
        firstName: foundUser.firstName,
        lastName: foundUser.lastName,
        email: foundUser.email,
        phone: foundUser.phone,
        role: foundUser.role,
        assignedProjects: foundUser.assignedProjects || [],
        assignedChannels: foundUser.assignedChannels || {},
        organizationId: organizationId,
        permissions: foundUser.permissions,
        approvalStatus: foundUser.approvalStatus,
        address1: foundUser.address1,
        address2: foundUser.address2,
        isOrgAdmin: isOrgAdminNow,
      });

      setUsers(members);

      // Fetch roles for the organization
      const rolesSnap = await getDocs(
        collection(db, "organization", organizationId, "roles")
      );
      const rolesData = rolesSnap.docs.map(
        (roleDoc) => ({ id: roleDoc.id, ...roleDoc.data() } as Role)
      );
      setRoles(rolesData);

      // Fetch projects for the user's organization
      const projectSnapshot = await getDocs(
        collection(db, `organization/${organizationId}/projects`)
      );

      const projectsData = await Promise.all(
        projectSnapshot.docs.map(async (doc) => {
          const data = doc.data();
          const projectId = doc.id;

          // Fetch the channels subcollection
          const channelsSnapshot = await getDocs(
            collection(
              db,
              `organization/${organizationId}/projects/${projectId}/channels`
            )
          );

          const channels = channelsSnapshot.docs.map(
            (channelDoc) => channelDoc.data().name || ""
          );
          const channelIds = channelsSnapshot.docs.map(
            (channelDoc) => channelDoc.id
          );

          return {
            id: projectId,
            description: data.description || "",
            status: data.status || "",
            createdAt: data.createdAt || "",
            name: data.name || "Untitled Project", // Default if `name` is missing
            channels, // Include fetched channels
            channelIds, // Include channel IDs for filtering
            assignedUsers: data.assignedUsers || [],
            createdBy: data.createdBy || "",
            // Optional field
          };
        })
      );
      // console.log("projects Data", projectsData);
      setProjects(projectsData);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setisLoading(false);
      setIsInitialLoad(false);
    }
  };

  // Use fetchData inside useEffect
  useEffect(() => {
    fetchData();
  }, []);

  // Listen for Calendar details view request
  useEffect(() => {
    const handler = (e: Event) => {
      setShowCalendarDetails(true);
    };
    window.addEventListener(
      "zensight:view-leave-details",
      handler as EventListener
    );
    return () =>
      window.removeEventListener(
        "zensight:view-leave-details",
        handler as EventListener
      );
  }, []);

  // Reset details view when leaving Calendar tab
  useEffect(() => {
    if (activeTab !== "Calendar") {
      setShowCalendarDetails(false);
    }
  }, [activeTab]);

  useEffect(() => {
    if (!organizationId || !currentUser?.id) return;

    // 1️⃣ Build the doc reference
    const notifRef = doc(
      db,
      `organization/${organizationId}/notifications/${currentUser.id}`
    );

    // 2️⃣ Subscribe to real-time updates
    const unsubscribe = onSnapshot(
      notifRef,
      (snapshot) => {
        if (snapshot.exists()) {
          const msgs = snapshot.data().messages || [];
          const unreadCount = msgs.filter((n: any) => !n.read).length;
          setUnreadNotifications(unreadCount);
        } else {
          setUnreadNotifications(0);
        }
      },
      (error) => {
        console.error("Notifications listener error:", error);
        setUnreadNotifications(0);
      }
    );

    // 3️⃣ Cleanup on unmount or deps change
    return () => unsubscribe();
  }, [organizationId, currentUser?.id]);

  // Log Tab Navigation
  useEffect(() => {
    if (activeTab && currentUser && organizationId) {
      logActivity(
        `Visited ${activeTab} module`,
        `User visited the ${activeTab} module`,
        "info",
        "activity"
      ).catch(() => { });
    }
  }, [activeTab, currentUser, organizationId]);

  // Log Sign-in Event
  useEffect(() => {
    const logSignIn = async () => {
      if (!currentUser || !organizationId) return;

      const sessionKey = `hasLoggedSignIn_${currentUser.id}`;
      const hasLogged = sessionStorage.getItem(sessionKey);

      if (hasLogged) return;

      // Mark as logged immediately to prevent race conditions
      sessionStorage.setItem(sessionKey, "true");

      try {
        await logToSystem(organizationId, "auth", {
          type: "AUTH",
          user: `${currentUser.firstName} ${currentUser.lastName}`,
          email: currentUser.email,
          action: "Login",
          details: "User signed in successfully",
          status: "success",
        });
      } catch (error) {
        console.error("Error logging sign-in:", error);
      }
    };

    logSignIn();
  }, [currentUser, organizationId]);

  // Helper to log user activities - Refactored to support categories
  const logActivity = async (
    action: string,
    details: string,
    status: "success" | "warning" | "error" | "info" = "success",
    category: "users" | "actions" | "auth" | "activity" = "users"
  ) => {
    if (!currentUser || !organizationId) return;
    try {
      await logToSystem(organizationId, category, {
        type: (category === "actions" || category === "activity") ? "ACTIVITY" : "USER",
        user: `${currentUser.firstName} ${currentUser.lastName}`,
        email: currentUser.email,
        action: action,
        details: details,
        status: status,
      });
    } catch (error) {
      console.error("Error logging activity:", error);
    }
  };

  // Generate random password function
  const generateRandomPassword = (): string => {
    return Math.random().toString(36).slice(-8); // Simple random password generator
  };

  // Add or Update a User
  const handleAddOrUpdateUser = async () => {
    if (
      !newUser.firstName ||
      !newUser.lastName ||
      !newUser.email ||
      !newUser.phone ||
      !newUser.role
    ) {
      showToast({
        title: "Error",
        description: "Please fill in all fields.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    setIsUserSaving(true);

    try {
      const currentUserId = auth.currentUser?.uid;
      if (!currentUserId) {
        showToast({
          title: "Error",
          description: "No authenticated user found.",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
        return;
      }

      // Fetch organization details for the admin
      const userRef = doc(db, "users", currentUserId);
      const userDoc = await getDoc(userRef);
      if (!userDoc.exists()) {
        throw new Error("Admin user not found in the users collection.");
      }

      const adminData = userDoc.data();
      const organizationId = adminData.organizationId;
      if (!organizationId) {
        throw new Error("Admin has no organization assigned.");
      }

      const orgRef = doc(db, "organization", organizationId);
      const orgDoc = await getDoc(orgRef);
      if (!orgDoc.exists()) {
        throw new Error("Organization not found.");
      }

      const orgData = orgDoc.data();

      if (editingUser) {
        // Update existing user inside organization members array
        const updatedMembers = orgData.members.map((member: any) =>
          member.id === editingUser.id ? { ...member, ...newUser } : member
        );

        await updateDoc(orgRef, { members: updatedMembers });

        // Sync changes to the users collection
        const userRef = doc(db, "users", editingUser.id);
        const userUpdateData: any = {
          firstName: newUser.firstName,
          lastName: newUser.lastName,
          email: newUser.email,
          phone: newUser.phone,
          role: newUser.role,
        };

        if (newUser.joiningDate !== undefined) userUpdateData.joiningDate = newUser.joiningDate;
        if (newUser.employeeCode !== undefined) userUpdateData.employeeCode = newUser.employeeCode;

        // Map department to dept for compatibility with ProfileMenu
        if (newUser.department !== undefined) {
          userUpdateData.department = newUser.department;
          userUpdateData.dept = newUser.department; // Sync for ProfileMenu
        }
        if (newUser.address1 !== undefined) userUpdateData.address1 = newUser.address1;
        if (newUser.address2 !== undefined) userUpdateData.address2 = newUser.address2;

        await updateDoc(userRef, userUpdateData);

        setUsers(updatedMembers);

        // Calculate changes for logging
        const changes: string[] = [];
        if (editingUser.firstName !== newUser.firstName) changes.push(`First Name: "${editingUser.firstName}" -> "${newUser.firstName}"`);
        if (editingUser.lastName !== newUser.lastName) changes.push(`Last Name: "${editingUser.lastName}" -> "${newUser.lastName}"`);
        if (editingUser.email !== newUser.email) changes.push(`Email: "${editingUser.email}" -> "${newUser.email}"`);
        if (editingUser.phone !== newUser.phone) changes.push(`Phone: "${editingUser.phone}" -> "${newUser.phone}"`);
        if (editingUser.role !== newUser.role) changes.push(`Role: "${editingUser.role}" -> "${newUser.role}"`);
        if (newUser.department && editingUser.department !== newUser.department) changes.push(`Department: "${editingUser.department || 'N/A'}" -> "${newUser.department}"`);

        const changeDetails = changes.length > 0 ? changes.join(", ") : "No specific details changed";

        // Log "User Updated" Activity
        await logActivity(
          "Updated User",
          `Updated details for ${newUser.firstName} ${newUser.lastName} (${newUser.email}). Changes: ${changeDetails}`
        );

        showToast({
          title: "Success",
          description: "User updated successfully.",
          status: "success",
          duration: 3000,
          isClosable: true,
        });
      } else {
        const currentUser = auth.currentUser;
        if (!currentUser) {
          showToast({
            title: "Error",
            description: "No authenticated user found.",
            status: "error",
            duration: 3000,
            isClosable: true,
          });
          return;
        }
        await setPersistence(auth, browserSessionPersistence);

        // ✅ Generate random password for new user
        const randomPassword = Math.random().toString(36).slice(-8);
        let userCredential;

        // ✅ Create user in Firebase Authentication
        try {
          userCredential = await createUserWithEmailAndPassword(
            auth,
            newUser.email,
            randomPassword
          );
          // console.log(
          //   "User created in Firebase Authentication:",
          //   userCredential.user.uid
          // );

          await signOut(auth);

          // ✅ Re-Sign In the Admin Silently (Session still exists)
          await auth.updateCurrentUser(currentUser);
        } catch (authError) {
          console.error(
            "Error creating user in Firebase Authentication:",
            authError
          );
          const errorMessage =
            (authError as Error).message ||
            "Failed to create user in Firebase Authentication.";
          showToast({
            title: "Error",
            description: errorMessage,
            status: "error",
            duration: 3000,
            isClosable: true,
          });
          return;
        }

        // ✅ Add new user to Firestore `users` collection
        const newUserRef = doc(db, "users", userCredential.user.uid);
        await setDoc(newUserRef, {
          id: userCredential.user.uid,
          firstName: newUser.firstName,
          lastName: newUser.lastName,
          email: newUser.email,
          phone: newUser.phone,
          role: newUser.role,
          organizationId: organizationId, // Assign to same organization
          adminId: currentUserId, // Link to admin who created the user
          createdAt: serverTimestamp(),
          address1: newUser.address1 || "",
          address2: newUser.address2 || "",
        });

        // ✅ Add user to organization members array
        const updatedMembers = [
          ...orgData.members,
          { id: userCredential.user.uid, ...newUser },
        ];
        await updateDoc(orgRef, { members: updatedMembers });

        // Log "User Added" Activity
        await logActivity(
          "Added User",
          `Added new user ${newUser.firstName} ${newUser.lastName} (${newUser.email})`
        );

        try {
          const response = await axios.post(`${backendUrl}/api/email/send`, {
            email: newUser.email,
            firstName: newUser.firstName,
            lastName: newUser.lastName,
            password: randomPassword, // Send generated password via email
          });

        } catch (emailError) {
          console.error("Error sending email:", emailError);
          showToast({
            title: "Error",
            description:
              (emailError as Error).message || "Failed to Send email.",
            status: "error",
            duration: 3000,
            isClosable: true,
          });
          return;
        }

        setUsers(updatedMembers);
        showToast({
          title: "Success",
          description: "User added successfully.",
          status: "success",
          duration: 3000,
          isClosable: true,
        });
      }

      // Reset input fields and close modal
      setNewUser({
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        role: "",
        organizationId: "",
      });

      onUserModalClose();
      setEditingUser(null);
    } catch (error) {
      console.error("Error adding/updating user:", error);
      showToast({
        title: "Error",
        description: "Failed to add or update user. Please try again.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setIsUserSaving(false);
    }
  };

  const handleDeleteUser = async (userId: string, reason: string) => {
    try {
      const currentUserId = auth.currentUser?.uid;
      if (!currentUserId) {
        showToast({
          title: "Error",
          description: "No authenticated user found.",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
        return;
      }

      // Fetch the organization ID for the current admin
      const orgSnapshot = await getDocs(collection(db, "organization"));
      let organizationId: string | null = null;

      for (const orgDoc of orgSnapshot.docs) {
        const orgData = orgDoc.data();
        const member = orgData.members?.find(
          (m: any) => m.id === currentUserId
        );
        if (member) {
          organizationId = orgDoc.id;
          break;
        }
      }

      if (!organizationId) {
        showToast({
          title: "Error",
          description: "Organization not found for the current user.",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
        return;
      }

      const orgRef = doc(db, "organization", organizationId);
      const orgDoc = await getDoc(orgRef);
      const orgData = orgDoc.data();

      if (!orgData || !orgData.members) {
        showToast({
          title: "Error",
          description: "Organization data or members array is missing.",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
        return;
      }

      // Remove the user from the organization's `members` array
      const updatedMembers = orgData.members.filter(
        (member: any) => member.id !== userId
      );

      // Reference to the projects subcollection
      const projectsRef = collection(
        db,
        `organization/${organizationId}/projects`
      );
      const projectSnapshot = await getDocs(projectsRef);

      const batch = writeBatch(db);

      // Iterate through all projects and remove the user from the assignedUsers field
      projectSnapshot.docs.forEach((projectDoc) => {
        const projectData = projectDoc.data();
        const assignedUsers = projectData.assignedUsers || [];

        if (assignedUsers.includes(userId)) {
          const updatedAssignedUsers = assignedUsers.filter(
            (id: string) => id !== userId
          );
          const projectDocRef = doc(
            db,
            `organization/${organizationId}/projects/${projectDoc.id}`
          );
          batch.update(projectDocRef, { assignedUsers: updatedAssignedUsers });
        }
      });

      // Fetch user details before deletion for audit
      const userRef = doc(db, "users", userId);
      const userSnap = await getDoc(userRef);
      const userData = userSnap.data() || {};

      // Delete user from `users` collection
      batch.delete(userRef);

      // Update the organization members
      batch.update(orgRef, { members: updatedMembers });

      // Write audit entry under organization/{orgId}/audit/deletions (append to entries array)
      const auditDocRef = doc(
        db,
        "organization",
        organizationId,
        "audit",
        "deletions"
      );
      batch.set(
        auditDocRef,
        { organizationId, type: "userDeletion", createdAt: serverTimestamp() },
        { merge: true }
      );
      batch.update(auditDocRef, {
        entries: arrayUnion({
          userId,
          firstName: userData.firstName || null,
          lastName: userData.lastName || null,
          email: userData.email || null,
          phone: userData.phone || null,
          role: userData.role || null,
          reason,
          deletedBy: currentUserId,
          deletedAt: new Date(),
        }),
      });

      await batch.commit();

      // Log "User Deleted" Activity
      await logActivity(
        "Deleted User",
        `Deleted user ${userData.firstName || ""} ${userData.lastName || ""} (${userData.email || userId}). Reason: ${reason}`
      );

      // **Delete user from Firebase Authentication using backend API**
      try {
        const response = await axios.delete(
          `${backendUrl}/api/user/delete/${userId}`
        );
        if (response.data.success) {
          console.log(
            "User deleted from Firebase Authentication successfully."
          );
        } else {
          console.warn(
            "Failed to delete user from Firebase Authentication:",
            response.data.message
          );
        }
      } catch (authError: any) {
        console.warn(
          "Could not delete user from Firebase Authentication:",
          authError.response?.data?.message || authError.message
        );

        // Show a warning toast but don't fail the entire operation
        // The user is already removed from Firestore and organization
        showToast({
          title: "Partial Success",
          description:
            "User removed from organization but could not be deleted from authentication. Please contact support.",
          status: "warning",
          duration: 5000,
          isClosable: true,
        });
      }

      // Update local state
      setUsers(updatedMembers);
      await fetchUsers();
      await fetchProjects();

      showToast({
        title: "Success",
        description: "User deleted successfully.",
        status: "success",
        duration: 3000,
        isClosable: true,
      });
    } catch (error) {
      console.error("Error deleting user:", error);
      showToast({
        title: "Error",
        description: "Failed to delete user. Please try again.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  // Add a Project
  const handleAddProject = async () => {
    if (!canCreateProject) {
      showToast({
        title: "Permission Restricted",
        description: "You do not have permission to add a project.",
        status: "warning",
        duration: 3000,
        isClosable: true,
      });
      return;
    }
    setIsProjectSaving(true);
    // Check if project name is empty
    if (!newProject.name) {
      showToast({
        title: "Missing Project Name",
        description: "Please enter a project name.",
        status: "warning",
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    // Check if channels contain empty values
    if (editChannelInputs.some((input) => !input.name.trim())) {
      showToast({
        title: "Empty Channel Name",
        description:
          "Please fill in all channel names before adding the project.",
        status: "warning",
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    try {
      // Ensure we have a valid current user
      const userId = auth.currentUser?.uid;
      if (!userId) {
        showToast({
          title: "Error",
          description: "No authenticated user found.",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
        return;
      }

      // Fetch the organization ID for the current user
      const orgSnapshot = await getDocs(collection(db, "organization"));
      let organizationId = null;

      for (const orgDoc of orgSnapshot.docs) {
        const orgData = orgDoc.data();
        const member = orgData.members?.find((m: any) => m.id === userId);
        if (member) {
          organizationId = orgDoc.id;
          break;
        }
      }

      if (!organizationId) {
        showToast({
          title: "Error",
          description: "Organization not found for the current user.",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
        return;
      }

      // Reference to the 'projects' subcollection
      const projectsRef = collection(
        db,
        `organization/${organizationId}/projects`
      );

      // Add a new project document to the 'projects' subcollection
      const projectDocRef = await addDoc(projectsRef, {
        name: newProject.name,
        description: newProject.description || "No description provided",
        createdAt: new Date(),
        createdBy: userId,
        status: "active",
        assignedUsers: [],
      });

      // Add channels as a subcollection under the created project
      const channelsRef = collection(
        db,
        `organization/${organizationId}/projects/${projectDocRef.id}/channels`
      );

      // Add each channel as a document in the 'channels' subcollection
      const channelPromises = channelInputs.map((channelName) =>
        addDoc(channelsRef, {
          name: channelName,
          createdAt: new Date(),
          createdBy: userId,
        })
      );

      await Promise.all(channelPromises);

      // Log "Project Added" Activity
      const channelDetails = channelInputs.length > 0
        ? `with channels: ${channelInputs.join(", ")}`
        : "with no channels";

      await logActivity(
        "Added Project",
        `Created new project "${newProject.name}" ${channelDetails}`,
        "success",
        "actions"
      );

      // Update the local state
      setProjects([
        ...projects,
        {
          id: projectDocRef.id,
          name: newProject.name,
          description: newProject.description,
          channels: channelInputs,
          assignedUsers: [],
        },
      ]);

      // Reset states
      // Reset states
      setNewProject({ name: "", description: "", channels: [] });
      setShowProjectForm(!showProjectForm);
      setChannelInputs([]);
      setSelectedProjectId(projectDocRef.id);

      showToast({
        title: "Project Added",
        description: "Project and channels added successfully!",
        status: "success",
        duration: 3000,
        isClosable: true,
      });
    } catch (error) {
      console.error("Error adding project:", error);
      showToast({
        title: "Failed to Add Project",
        description: "Could not add the project. Please try again.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setIsProjectSaving(false);
      onAddProjectModalClose();
    }
  };

  // Add a Channel to the Selected Project

  // Delete a Project
  const handleDeleteProject = async (projectId: string) => {
    const targetProject = projects.find((p) => p.id === projectId);
    if (!canDeleteProject(targetProject || undefined)) {
      showToast({
        title: "Permission Restricted",
        description: "You do not have permission to delete this project.",
        status: "warning",
        duration: 3000,
        isClosable: true,
      });
      return;
    }
    try {
      const currentUserId = auth.currentUser?.uid;

      if (!currentUserId) {
        showToast({
          title: "Error",
          description: "No authenticated user found.",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
        return;
      }

      const organizationId = await findOrganizationId(db, currentUserId);

      if (!organizationId) return;

      // Get the project name before deletion for cleanup
      const projectRef = doc(
        db,
        `organization/${organizationId}/projects/${projectId}`
      );
      const projectDoc = await getDoc(projectRef);
      const projectName = projectDoc.exists() ? projectDoc.data().name : "";

      // Get all users in the organization to clean up their references
      const orgRef = doc(db, "organization", organizationId);
      const orgDoc = await getDoc(orgRef);

      if (!orgDoc.exists()) {
        throw new Error("Organization not found");
      }

      const orgData = orgDoc.data();
      const members = orgData.members || [];

      // Create a batch for all updates
      const batch = writeBatch(db);

      // Update each member in the organization to remove project references
      const updatedMembers = members.map((member: any) => {
        const updatedMember = { ...member };

        // Remove project from assignedProjects array
        if (
          updatedMember.assignedProjects &&
          updatedMember.assignedProjects.includes(projectId)
        ) {
          updatedMember.assignedProjects =
            updatedMember.assignedProjects.filter(
              (id: string) => id !== projectId
            );
        }

        // Remove project from assignedChannels object
        if (
          updatedMember.assignedChannels &&
          updatedMember.assignedChannels[projectId]
        ) {
          delete updatedMember.assignedChannels[projectId];
        }

        // Remove tasks related to this project from assignedTasks array
        if (updatedMember.assignedTasks) {
          updatedMember.assignedTasks = updatedMember.assignedTasks.filter(
            (task: any) => task.projectId !== projectId
          );
        }

        return updatedMember;
      });

      // Update organization members
      batch.update(orgRef, { members: updatedMembers });

      // Update individual user documents in the users collection
      for (const member of members) {
        const userRef = doc(db, "users", member.id);
        const userDoc = await getDoc(userRef);

        if (userDoc.exists()) {
          const userData = userDoc.data();
          const updates: any = {};

          // Remove project from assignedProjects
          if (
            userData.assignedProjects &&
            userData.assignedProjects.includes(projectId)
          ) {
            updates.assignedProjects = arrayRemove(projectId);
          }

          // Remove project from assignedChannels
          if (
            userData.assignedChannels &&
            userData.assignedChannels[projectId]
          ) {
            const updatedChannels = { ...userData.assignedChannels };
            delete updatedChannels[projectId];
            updates.assignedChannels = updatedChannels;
          }

          // Remove tasks related to this project
          if (userData.assignedTasks) {
            const tasksToRemove = userData.assignedTasks.filter(
              (task: any) => task.projectId === projectId
            );

            if (tasksToRemove.length > 0) {
              updates.assignedTasks = userData.assignedTasks.filter(
                (task: any) => task.projectId !== projectId
              );
            }
          }

          // Only update if there are changes
          if (Object.keys(updates).length > 0) {
            batch.update(userRef, updates);
          }
        }
      }

      // Delete the project document
      batch.delete(projectRef);

      // Commit all changes
      await batch.commit();

      // Drop this project from every user's project-access map so revoked ids
      // don't linger after the project is gone.
      await removeProjectFromAllAccess(organizationId, projectId);

      // Log "Project Deleted" Activity
      await logActivity(
        "Deleted Project",
        `Deleted project "${projectName}"`,
        "success",
        "actions"
      );

      // Update local state
      setProjects((prevProjects) =>
        prevProjects.filter((project) => project.id !== projectId)
      );

      showToast({
        title: "Success",
        description: `Project "${projectName}" deleted successfully and all references cleaned up.`,
        status: "success",
        duration: 3000,
        isClosable: true,
      });
    } catch (error) {
      console.error("Error deleting project:", error);
      showToast({
        title: "Error",
        description: "Failed to delete project. Please try again.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  // Assign User to a Project

  // Add a new input box for channels
  const handleAddChannelInput = () => {
    setChannelInputs([...channelInputs, ""]); // Add empty string for new input
  };

  // Remove a specific input box by index
  const handleRemoveChannelInput = (index: number) => {
    const updatedInputs = channelInputs.filter((_, i) => i !== index); // Remove at index
    setChannelInputs(updatedInputs);
  };

  // Update value in a specific input box
  const handleChannelInputChange = (index: number, value: string) => {
    const updatedInputs = [...channelInputs];
    updatedInputs[index] = value; // Update value at index
    setChannelInputs(updatedInputs);
  };

  // Save channels to the selected project

  const handleEditProject = async (project: Project) => {
    if (!canEditProject(project)) {
      showToast({
        title: "Access Restricted",
        description: `You do not have edit access to "${project.name}". Please contact your administrator to request access.`,
        status: "warning",
        duration: 4000,
        isClosable: true,
        position: "bottom-right",
      });
      return;
    }
    setEditingProject(project);
    setEditProjectName(project.name);

    // 🔍 Fetch the channels subcollection so we get each doc's ID:
    const channelsCol = collection(
      db,
      "organization",
      organizationId,
      "projects",
      project.id,
      "channels"
    );
    const channelsSnap = await getDocs(channelsCol);
    const inputs: ChannelInput[] = channelsSnap.docs.map((d) => ({
      id: d.id,
      name: d.data().name as string,
    }));
    setEditChannelInputs(inputs);

    onProjectModalOpen();
  };

  const fetchUsers = async () => {
    try {
      const userId = auth.currentUser?.uid;
      if (!userId) {
        console.error("No authenticated user found.");
        return;
      }

      // Fetch all organizations and find the organization where the user is a member
      const orgSnapshot = await getDocs(collection(db, "organization"));

      let organizationId: string | null = null;
      let organizationData: any = null;

      for (const orgDoc of orgSnapshot.docs) {
        const orgData = orgDoc.data();

        // Check if the current user is a member of this organization
        const isMember = orgData.members?.some(
          (member: any) => member.id === userId
        );

        if (isMember) {
          organizationId = orgDoc.id;
          organizationData = orgData;
          break;
        }
      }

      if (!organizationId || !organizationData) {
        console.error("Organization not found for the current user.");
        return;
      }

      // Extract members from the organization
      const usersData = organizationData.members.map((member: any) => ({
        id: member.id,
        ...member,
      }));

      setUsers(usersData);
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  const fetchProjects = async () => {
    try {
      const userId = auth.currentUser?.uid;

      if (!userId) {
        console.error("No authenticated user found.");
        return;
      }

      // Fetch all organizations and identify where the user is a member
      const orgSnapshot = await getDocs(collection(db, "organization"));
      let organizationId: string | null = null;

      for (const orgDoc of orgSnapshot.docs) {
        const orgData = orgDoc.data();

        // Check if the current user is a member of this organization
        const isMember = orgData.members?.some(
          (member: any) => member.id === userId
        );

        if (isMember) {
          organizationId = orgDoc.id;
          break;
        }
      }

      if (!organizationId) {
        console.error("Organization not found for the current user.");
        return;
      }

      // Fetch projects for the organization
      const projectsRef = collection(
        db,
        `organization/${organizationId}/projects`
      );
      const projectSnapshot = await getDocs(projectsRef);

      const projectsData = await Promise.all(
        projectSnapshot.docs.map(async (doc) => {
          const projectData = doc.data();
          const projectId = doc.id;

          // Fetch channels for each project
          const channelsRef = collection(
            db,
            `organization/${organizationId}/projects/${projectId}/channels`
          );
          const channelsSnapshot = await getDocs(channelsRef);

          // Map channels to an array of names
          const channels = channelsSnapshot.docs.map(
            (channelDoc) => channelDoc.data().name || "Unnamed Channel"
          );
          const channelIds = channelsSnapshot.docs.map(
            (channelDoc) => channelDoc.id
          );

          return {
            id: projectId,
            name: projectData.name || "Untitled Project", // Default if no name provided
            assignedUsers: projectData.assignedUsers || [], // Optional field
            channels, // Now an array of strings (channel names)
            channelIds, // Channel IDs for filtering
            createdBy: projectData.createdBy || "",
          };
        })
      );

      setProjects(projectsData); // Update the state with the fetched projects
    } catch (error) {
      console.error("Error fetching projects:", error);
    }
  };

  const handleUpdateProject = async () => {
    if (!editingProject) return;
    if (!canEditProject(editingProject)) {
      showToast({
        title: "Permission Restricted",
        description: "You do not have permission to update this project.",
        status: "warning",
        duration: 3000,
        isClosable: true,
      });
      return;
    }
    if (!editProjectName.trim()) {
      showToast({
        title: "Missing Project Name",
        status: "warning",
        duration: 3000,
        isClosable: true,
      });
      return;
    }
    if (editChannelInputs.some((input) => !input.name.trim())) {
      showToast({
        title: "Empty Channel Name",
        status: "warning",
        duration: 3000,
        isClosable: true,
      });
      return;
    }
    setIsProjectUpdating(true);
    try {
      const userId = auth.currentUser?.uid;
      if (!userId) {
        showToast({
          title: "Error",
          description: "No authenticated user found.",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
        return;
      }

      const orgSnap = await getDocs(collection(db, "organization"));
      let organizationId: string | null = null;
      for (const o of orgSnap.docs) {
        if (o.data().members?.some((m: any) => m.id === userId)) {
          organizationId = o.id;
          break;
        }
      }
      if (!organizationId) {
        showToast({
          title: "Error",
          description: "Organization not found for the current user.",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
        return;
      }

      const projectRef = doc(
        db,
        "organization",
        organizationId,
        "projects",
        editingProject.id
      );
      await updateDoc(projectRef, { name: editProjectName });

      const channelsCol = collection(
        db,
        "organization",
        organizationId,
        "projects",
        editingProject.id,
        "channels"
      );
      const existingSnap = await getDocs(channelsCol);
      const existingChannels = existingSnap.docs.map((d) => ({
        id: d.id,
        name: d.data().name as string,
      }));

      const inputNames = editChannelInputs.map((ch) => ch.name.trim());
      const inputIds = editChannelInputs.map((ch) => ch.id).filter((id) => id !== "");
      const toRemove = existingChannels
        .filter((ch) => !inputIds.includes(ch.id))
        .map((ch) => ch.id);
      const toAdd = editChannelInputs
        .filter((ch) => !ch.id)
        .map((ch) => ch.name.trim());

      // Get organization data for cleanup
      const orgRef = doc(db, "organization", organizationId);
      const orgDoc = await getDoc(orgRef);
      const orgData = orgDoc.data();
      const members = orgData?.members || [];

      // ─── start a batch ───
      const batch = writeBatch(db);

      // 1️⃣ rename existing or create new
      editChannelInputs.forEach((ch) => {
        if (!ch.name.trim()) return; // skip blanks
        if (ch.id) {
          // existing → just update name
          const ref = doc(channelsCol, ch.id);
          batch.update(ref, { name: ch.name, updatedAt: new Date() });
        } else {
          // new → create
          const newRef = doc(channelsCol);
          batch.set(newRef, { name: ch.name, updatedAt: new Date() });
        }
      });

      // Log "Project Updated" Activity
      // Note: We are doing this before commit, but it runs as a separate async op. Ideally should be after commit or part of it if logActivity supported batch (it doesn't).
      // We'll place it after the batch commit to ensure success.

      // 2️⃣ delete ones the user dropped
      existingChannels
        .filter((ec) => !editChannelInputs.some((ch) => ch.id === ec.id))
        .forEach((ec) => batch.delete(doc(channelsCol, ec.id)));

      // 3️⃣ Update organization members to remove references to deleted channels
      if (toRemove.length > 0) {
        const updatedMembers = members.map((member: any) => {
          const updatedMember = { ...member };

          // Remove channels from assignedChannels for this project
          if (
            updatedMember.assignedChannels &&
            updatedMember.assignedChannels[editingProject.id]
          ) {
            const projectChannels =
              updatedMember.assignedChannels[editingProject.id] || [];
            const remainingChannels = projectChannels.filter(
              (channelId: string) => !toRemove.includes(channelId)
            );

            if (remainingChannels.length === 0) {
              // If no channels left for this project, remove the project entry
              delete updatedMember.assignedChannels[editingProject.id];
            } else {
              updatedMember.assignedChannels[editingProject.id] =
                remainingChannels;
            }
          }

          // Remove tasks related to deleted channels
          if (updatedMember.assignedTasks) {
            updatedMember.assignedTasks = updatedMember.assignedTasks.filter(
              (task: any) =>
                !(
                  task.projectId === editingProject.id &&
                  toRemove.includes(task.channelId)
                )
            );
          }

          return updatedMember;
        });

        // Update organization members
        batch.update(orgRef, { members: updatedMembers });

        // 4️⃣ Update individual user documents
        for (const member of members) {
          const userRef = doc(db, "users", member.id);
          const userDoc = await getDoc(userRef);

          if (userDoc.exists()) {
            const userData = userDoc.data();
            const updates: any = {};

            // Remove tasks from assignedTasks
            if (userData.assignedTasks) {
              const updatedTasks = userData.assignedTasks.filter(
                (task: any) =>
                  !(
                    task.projectId === editingProject.id &&
                    toRemove.includes(task.channelId)
                  )
              );
              if (updatedTasks.length !== userData.assignedTasks.length) {
                updates.assignedTasks = updatedTasks;
              }
            }

            // Update assignedChannels for this project
            if (
              userData.assignedChannels &&
              userData.assignedChannels[editingProject.id]
            ) {
              const projectChannels =
                userData.assignedChannels[editingProject.id] || [];
              const remainingChannels = projectChannels.filter(
                (channelId: string) => !toRemove.includes(channelId)
              );

              if (remainingChannels.length === 0) {
                // If no channels left for this project, remove the project entry
                const updatedChannels = { ...userData.assignedChannels };
                delete updatedChannels[editingProject.id];
                updates.assignedChannels = updatedChannels;
              } else {
                updates.assignedChannels = {
                  ...userData.assignedChannels,
                  [editingProject.id]: remainingChannels,
                };
              }
            }

            // Only update if there are changes
            if (Object.keys(updates).length > 0) {
              batch.update(userRef, updates);
            }
          }
        }
      }

      // 5️⃣ commit the batch
      await batch.commit();

      // Log Project Update
      await logActivity(
        "Updated Project",
        `Updated project "${editProjectName}"`,
        "success",
        "actions"
      );

      // Calculate changes for logging
      const changes: string[] = [];
      if (editingProject.name !== editProjectName) {
        changes.push(`Project Name: "${editingProject.name}" -> "${editProjectName}"`);
      }

      // Channel changes
      const oldChannelNames = existingChannels.map(ch => ch.name).sort();
      const newChannelNames = inputNames.sort();

      if (toAdd.length > 0) {
        changes.push(`Added Channels: ${toAdd.join(", ")}`);
      }
      if (toRemove.length > 0) {
        const removedNames = existingChannels.filter(ch => toRemove.includes(ch.id)).map(ch => ch.name);
        changes.push(`Removed Channels: ${removedNames.join(", ")}`);
      }

      const changeDetails = changes.length > 0 ? changes.join("; ") : "No changes";

      // Log "Project Updated" Activity
      await logActivity(
        "Updated Project",
        `Updated project "${editProjectName}". Changes: ${changeDetails}`
      );

      setProjects((prev) =>
        prev.map((p) =>
          p.id === editingProject.id
            ? { ...p, name: editProjectName, channels: inputNames }
            : p
        )
      );

      showToast({
        title: "Project Updated",
        description: "Project and channels updated successfully!",
        status: "success",
        duration: 3000,
        isClosable: true,
      });

      onProjectModalClose();
      fetchProjects();
      fetchUsers();
      setEditingProject(null);
      setEditProjectName("");
      setEditChannelInputs([]);
    } catch (error) {
      console.error("Error updating project:", error);
      showToast({
        title: "Failed to Update Project",
        description: "Could not update the project. Please try again.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setIsProjectUpdating(false);
    }
  };

  const handleOpenAssignProjects = (user: User) => {
    if (!canAssignProjects) {
      showToast({
        title: "Permission Restricted",
        description: "You do not have permission to assign projects.",
        status: "warning",
        duration: 3000,
        isClosable: true,
      });
      return;
    }
    setSelectedUser(user); // Set the selected user
    onAssignProjectsOpen(); // Open modal
  };

  const handleUpdatePermission = async (userId: string, newPermission: string) => {
    try {
      if (!organizationId) return;

      // 1. Update in Organization members array (source of truth for this dashboard list mostly)
      const orgRef = doc(db, "organization", organizationId);
      const orgDoc = await getDoc(orgRef);

      if (orgDoc.exists()) {
        const orgData = orgDoc.data();
        const members = orgData.members || [];

        // Find the member to get their current permission before update
        const memberToUpdate = members.find((member: any) => member.id === userId);
        const oldPermission = memberToUpdate?.permissions || "None";

        const updatedMembers = members.map((member: any) => {
          if (member.id === userId) {
            if (newPermission) {
              return { ...member, permissions: newPermission };
            } else {
              // Omit permissions field entirely when clearing
              const { permissions, ...memberWithoutPermissions } = member;
              return memberWithoutPermissions;
            }
          }
          return member;
        });

        await updateDoc(orgRef, { members: updatedMembers });

        // 2. Update in Users collection (for user profile consistency)
        const userRef = doc(db, "users", userId);
        if (newPermission) {
          await updateDoc(userRef, { permissions: newPermission });
        } else {
          // Remove the permissions field if empty
          await updateDoc(userRef, { permissions: deleteField() });
        }

        // 3. Update local state
        setUsers((prevUsers) =>
          prevUsers.map((u) =>
            u.id === userId ? { ...u, permissions: (newPermission || undefined) as any } : u
          )
        );

        // 4. Log work group permission update activity
        try {
          const currentUserAuth = auth.currentUser;
          if (currentUserAuth && organizationId && memberToUpdate) {
            const authUserRef = doc(db, "users", currentUserAuth.uid);
            const authUserSnap = await getDoc(authUserRef);

            if (authUserSnap.exists()) {
              const authUserData = authUserSnap.data();
              await logToSystem(organizationId, "actions", {
                type: "ACTIVITY",
                user: `${authUserData.firstName} ${authUserData.lastName}`,
                email: authUserData.email,
                action: "Work Group",
                details: `Updated work group permission for ${memberToUpdate.firstName} ${memberToUpdate.lastName} from ${oldPermission} to ${newPermission || "None"}`,
                status: "success",
              });
            }
          }
        } catch (logError) {
          console.error("Error logging work group permission update:", logError);
        }

        showToast({
          title: "Permission Updated",
          description: newPermission
            ? `User permission set to ${newPermission}`
            : "User permission cleared",
          status: "success",
          duration: 3000,
          isClosable: true,
        });
      }
    } catch (error) {
      console.error("Error updating permission:", error);
      showToast({
        title: "Update Failed",
        description: "Could not update user permission.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  const handleAddRole = async (name: string, permission: string, approvalStatus: string) => {
    try {
      if (!organizationId) return;
      if (!name.trim()) {
        showToast({ title: "Validation Error", description: "Role name is required.", status: "warning", duration: 3000, isClosable: true });
        return;
      }
      if (!approvalStatus) {
        showToast({ title: "Validation Error", description: "Please select an approval status.", status: "warning", duration: 3000, isClosable: true });
        return;
      }
      const duplicate = roles.find((r) => r.name.toLowerCase() === name.trim().toLowerCase());
      if (duplicate) {
        showToast({ title: "Duplicate Role", description: "A role with this name already exists.", status: "warning", duration: 3000, isClosable: true });
        return;
      }

      const rolesRef = collection(db, "organization", organizationId, "roles");
      const docRef = await addDoc(rolesRef, {
        name: name.trim(),
        permission,
        approvalStatus,
        createdAt: serverTimestamp(),
        createdBy: auth.currentUser?.uid || "",
      });

      const newRole: Role = { id: docRef.id, name: name.trim(), permission: permission as "Admin" | "Editor" | "Viewer", approvalStatus: approvalStatus as "Yes" | "No" };
      setRoles((prev) => [...prev, newRole]);

      try {
        const currentUserAuth = auth.currentUser;
        if (currentUserAuth) {
          const authUserRef = doc(db, "users", currentUserAuth.uid);
          const authUserSnap = await getDoc(authUserRef);
          if (authUserSnap.exists()) {
            const authUserData = authUserSnap.data();
            await logToSystem(organizationId, "actions", {
              type: "ACTIVITY",
              user: `${authUserData.firstName} ${authUserData.lastName}`,
              email: authUserData.email,
              action: "Work Group",
              details: `Created new role "${name.trim()}" with ${permission} permission and approval status: ${approvalStatus}`,
              status: "success",
            });
          }
        }
      } catch (logError) {
        console.error("Error logging role creation:", logError);
      }

      showToast({ title: "Role Created", description: `Role "${name.trim()}" has been created.`, status: "success", duration: 3000, isClosable: true });
    } catch (error) {
      console.error("Error adding role:", error);
      showToast({ title: "Creation Failed", description: "Could not create role.", status: "error", duration: 3000, isClosable: true });
    }
  };

  const handleDeleteRole = async (roleId: string) => {
    try {
      if (!organizationId) return;

      const assignedUser = users.find((u: any) => u.workGroupRoleId === roleId);
      if (assignedUser) {
        showToast({ title: "Cannot Delete", description: "This role is assigned to a user. Unassign it first.", status: "warning", duration: 3000, isClosable: true });
        return;
      }

      const roleToDelete = roles.find((r) => r.id === roleId);
      await deleteDoc(doc(db, "organization", organizationId, "roles", roleId));
      setRoles((prev) => prev.filter((r) => r.id !== roleId));

      try {
        const currentUserAuth = auth.currentUser;
        if (currentUserAuth) {
          const authUserRef = doc(db, "users", currentUserAuth.uid);
          const authUserSnap = await getDoc(authUserRef);
          if (authUserSnap.exists()) {
            const authUserData = authUserSnap.data();
            await logToSystem(organizationId, "actions", {
              type: "ACTIVITY",
              user: `${authUserData.firstName} ${authUserData.lastName}`,
              email: authUserData.email,
              action: "Work Group",
              details: `Deleted role "${roleToDelete?.name || roleId}"`,
              status: "success",
            });
          }
        }
      } catch (logError) {
        console.error("Error logging role deletion:", logError);
      }

      showToast({ title: "Role Deleted", description: `Role "${roleToDelete?.name || roleId}" has been deleted.`, status: "success", duration: 3000, isClosable: true });
    } catch (error) {
      console.error("Error deleting role:", error);
      showToast({ title: "Delete Failed", description: "Could not delete role.", status: "error", duration: 3000, isClosable: true });
    }
  };

  const handleUpdateRole = async (roleId: string, newName: string, newPermission: string, newApprovalStatus?: string) => {
    try {
      if (!organizationId) return;

      const roleRef = doc(db, "organization", organizationId, "roles", roleId);
      const updateData: any = { name: newName.trim(), permission: newPermission };
      if (newApprovalStatus !== undefined) {
        updateData.approvalStatus = newApprovalStatus;
      }
      await updateDoc(roleRef, updateData);

      setRoles((prev) =>
        prev.map((r) =>
          r.id === roleId ? { ...r, name: newName.trim(), permission: newPermission as "Admin" | "Editor" | "Viewer", ...(newApprovalStatus !== undefined ? { approvalStatus: newApprovalStatus as "Yes" | "No" } : {}) } : r
        )
      );

      const assignedUsers = users.filter((u: any) => u.workGroupRoleId === roleId);
      for (const u of assignedUsers) {
        const userRef = doc(db, "users", u.id);
        const userUpdateData: any = { role: newName.trim(), permissions: newPermission };
        if (newApprovalStatus !== undefined) {
          userUpdateData.approvalStatus = newApprovalStatus;
        }
        await updateDoc(userRef, userUpdateData);

        const orgRef = doc(db, "organization", organizationId);
        const orgDoc = await getDoc(orgRef);
        if (orgDoc.exists()) {
          const members = orgDoc.data().members || [];
          const updatedMembers = members.map((m: any) =>
            m.id === u.id ? { ...m, role: newName.trim(), permissions: newPermission, ...(newApprovalStatus !== undefined ? { approvalStatus: newApprovalStatus } : {}) } : m
          );
          await updateDoc(orgRef, { members: updatedMembers });
        }

        setUsers((prev) =>
          prev.map((usr) =>
            usr.id === u.id ? { ...usr, role: newName.trim(), permissions: newPermission as any, ...(newApprovalStatus !== undefined ? { approvalStatus: newApprovalStatus as any } : {}) } : usr
          )
        );
      }

      // Update currentUser if the role was assigned to the current user
      if (currentUser && assignedUsers.some((u) => u.id === currentUser.id) && newApprovalStatus !== undefined) {
        setCurrentUser((prev) => prev ? { ...prev, approvalStatus: newApprovalStatus as "Yes" | "No" } : prev);
      }

      try {
        const currentUserAuth = auth.currentUser;
        if (currentUserAuth) {
          const authUserRef = doc(db, "users", currentUserAuth.uid);
          const authUserSnap = await getDoc(authUserRef);
          if (authUserSnap.exists()) {
            const authUserData = authUserSnap.data();
            await logToSystem(organizationId, "actions", {
              type: "ACTIVITY",
              user: `${authUserData.firstName} ${authUserData.lastName}`,
              email: authUserData.email,
              action: "Work Group",
              details: `Updated role "${newName.trim()}" permission to ${newPermission}${newApprovalStatus !== undefined ? `, approval status to ${newApprovalStatus}` : ""}`,
              status: "success",
            });
          }
        }
      } catch (logError) {
        console.error("Error logging role update:", logError);
      }

      showToast({ title: "Role Updated", description: `Role "${newName.trim()}" updated to ${newPermission}.${newApprovalStatus !== undefined ? ` Approval status: ${newApprovalStatus}` : ""}`, status: "success", duration: 3000, isClosable: true });
    } catch (error) {
      console.error("Error updating role:", error);
      showToast({ title: "Update Failed", description: "Could not update role.", status: "error", duration: 3000, isClosable: true });
    }
  };

  const handleAssignRole = async (userId: string, roleId: string) => {
    try {
      if (!organizationId) return;

      const orgRef = doc(db, "organization", organizationId);
      const orgDoc = await getDoc(orgRef);

      if (orgDoc.exists()) {
        const orgData = orgDoc.data();
        const members = orgData.members || [];
        const memberToUpdate = members.find((member: any) => member.id === userId);

        if (!memberToUpdate) return;

        const oldRole = memberToUpdate.role || "None";
        let newRoleName = "";
        let newPermission = "";
        let newApprovalStatus = "";

        if (roleId) {
          const roleDoc = roles.find((r) => r.id === roleId);
          if (roleDoc) {
            newRoleName = roleDoc.name;
            newPermission = roleDoc.permission;
            newApprovalStatus = roleDoc.approvalStatus || "No";
          }
        }

        const updatedMembers = members.map((member: any) => {
          if (member.id === userId) {
            if (roleId) {
              const roleDoc = roles.find((r) => r.id === roleId);
              return {
                ...member,
                role: roleDoc?.name || member.role,
                permissions: roleDoc?.permission || member.permissions,
                approvalStatus: roleDoc?.approvalStatus || "No",
                workGroupRoleId: roleId,
              };
            } else {
              const { workGroupRoleId, role, approvalStatus, ...memberWithoutRole } = member;
              return memberWithoutRole;
            }
          }
          return member;
        });

        await updateDoc(orgRef, { members: updatedMembers });

        const userRef = doc(db, "users", userId);
        if (roleId) {
          const roleDoc = roles.find((r) => r.id === roleId);
          await updateDoc(userRef, {
            role: roleDoc?.name || undefined,
            permissions: roleDoc?.permission || undefined,
            approvalStatus: roleDoc?.approvalStatus || "No",
            workGroupRoleId: roleId,
          });
        } else {
          await updateDoc(userRef, {
            permissions: deleteField(),
            approvalStatus: deleteField(),
            workGroupRoleId: deleteField(),
          });
        }

        setUsers((prevUsers) =>
          prevUsers.map((u) => {
            if (u.id === userId) {
              if (roleId) {
                const roleDoc = roles.find((r) => r.id === roleId);
                return {
                  ...u,
                  role: roleDoc?.name || u.role,
                  permissions: (roleDoc?.permission || u.permissions) as any,
                  approvalStatus: (roleDoc?.approvalStatus || "No") as any,
                  workGroupRoleId: roleId,
                };
              } else {
                const { workGroupRoleId, permissions, approvalStatus, ...rest } = u as any;
                return rest;
              }
            }
            return u;
          })
        );

        try {
          const currentUserAuth = auth.currentUser;
          if (currentUserAuth && memberToUpdate) {
            const authUserRef = doc(db, "users", currentUserAuth.uid);
            const authUserSnap = await getDoc(authUserRef);
            if (authUserSnap.exists()) {
              const authUserData = authUserSnap.data();
              await logToSystem(organizationId, "actions", {
                type: "ACTIVITY",
                user: `${authUserData.firstName} ${authUserData.lastName}`,
                email: authUserData.email,
                action: "Work Group",
                details: roleId
                  ? `Assigned role "${newRoleName}" to ${memberToUpdate.firstName} ${memberToUpdate.lastName} (from ${oldRole} to ${newRoleName})`
                  : `Removed role from ${memberToUpdate.firstName} ${memberToUpdate.lastName} (from ${oldRole} to None)`,
                status: "success",
              });
            }
          }
        } catch (logError) {
          console.error("Error logging role assignment:", logError);
        }

        showToast({
          title: "Role Updated",
          description: roleId ? `Role set to "${newRoleName}"` : "Role removed",
          status: "success",
          duration: 3000,
          isClosable: true,
        });
      }
    } catch (error) {
      console.error("Error assigning role:", error);
      showToast({ title: "Update Failed", description: "Could not update user role.", status: "error", duration: 3000, isClosable: true });
    }
  };

  const handleUpdateUserApprovalStatus = async (userId: string, newApprovalStatus: string) => {
    try {
      if (!organizationId) return;

      // Update user document
      const userRef = doc(db, "users", userId);
      await updateDoc(userRef, { approvalStatus: newApprovalStatus });

      // Update organization members array
      const orgRef = doc(db, "organization", organizationId);
      const orgDoc = await getDoc(orgRef);
      if (orgDoc.exists()) {
        const members = orgDoc.data().members || [];
        const updatedMembers = members.map((m: any) =>
          m.id === userId ? { ...m, approvalStatus: newApprovalStatus } : m
        );
        await updateDoc(orgRef, { members: updatedMembers });
      }

      // Update local state
      setUsers((prev) =>
        prev.map((u) =>
          u.id === userId ? { ...u, approvalStatus: newApprovalStatus as "Yes" | "No" } : u
        )
      );

      // Update currentUser if it's the current user being updated
      if (currentUser?.id === userId) {
        setCurrentUser((prev) => prev ? { ...prev, approvalStatus: newApprovalStatus as "Yes" | "No" } : prev);
      }

      showToast({ title: "Approval Status Updated", description: `Approval status set to "${newApprovalStatus}".`, status: "success", duration: 3000, isClosable: true });
    } catch (error) {
      console.error("Error updating user approval status:", error);
      showToast({ title: "Update Failed", description: "Could not update approval status.", status: "error", duration: 3000, isClosable: true });
    }
  };

  useEffect(() => {
    if (activeTab === "Users") {
      setFilteredUsers(
        users.filter((user) =>
          `${user.firstName} ${user.lastName}`
            .toLowerCase()
            .includes(searchTerm.toLowerCase())
        )
      );
    } else if (activeTab === "Projects") {
      // Role-based project visibility: admin sees all; everyone else sees the
      // projects they are assigned to plus any they hold a project role on.
      const visibleProjects = projects.filter((project) =>
        canSeeProject(currentUser, project, { canViewAll: canViewAllProjects })
      );

      setFilteredProjects(
        visibleProjects.filter((project) =>
          project.name.toLowerCase().includes(searchTerm.toLowerCase())
        )
      );
    } else if (activeTab === "TimeSheets") {
      setFilteredUsers(
        users.filter((user) =>
          `${user.firstName} ${user.lastName}`
            .toLowerCase()
            .includes(searchTerm.toLowerCase())
        )
      );
    } else if (activeTab === "Burn-Out") {
      setFilteredUsers(
        users.filter((user) =>
          `${user.firstName} ${user.lastName}`
            .toLowerCase()
            .includes(searchTerm.toLowerCase())
        )
      );
    } else if (activeTab === "Tasks" || activeTab === "Progress") {
      // Same visibility rule as the Projects tab: assignment or a project role.
      const visibleProjects = projects.filter((project) =>
        canSeeProject(currentUser, project, { canViewAll: canViewAllProjects })
      );

      setFilteredProjects(
        visibleProjects.filter((project) =>
          project.name.toLowerCase().includes(searchTerm.toLowerCase())
        )
      );
    }
  }, [searchTerm, users, projects, activeTab, currentUser, projectPerms]);

  const isAdmin = hasAdminActionAccess;
  const isAdminVisible = canViewAdminModules;
  const isManagerVisible = canViewManagerModules;

  useEffect(() => {
    if (currentUser && organizationId) {
      const { tab, isAdmin: parsedIsAdmin } = parseModuleFromPath(location.pathname);
      const wantsAdmin = parsedIsAdmin || (tab && ADMIN_TABS.has(tab));
      const hasAdminPermission = canViewAdminModules || canViewManagerModules || hasApprovalStatus;

      if (wantsAdmin && !hasAdminPermission) {
        handleSetActiveTab("LogPanel");
        setIsAdminViewState(false);
      } else if (tab) {
        setActiveTabState(tab);
        setIsAdminViewState(parsedIsAdmin);
      } else {
        if (isAdminVisible) {
          handleSetActiveTab("Users");
        } else {
          handleSetActiveTab("LogPanel");
        }
      }
    }
  }, [
    currentUser,
    isAdminVisible,
    organizationId,
    canViewAdminModules,
    canViewManagerModules,
    hasApprovalStatus,
    handleSetActiveTab,
  ]);

  useEffect(() => {
    if (!organizationId || !currentUser?.id || !users) return;

    const fetchPendingCounts = async () => {
      try {
        const byUser: Record<string, any[]> = {};

        // Fetch from each user's collection
        // Note: For large organizations, this might need optimization
        await Promise.all(users.map(async (u) => {
          const tsColRef = collection(db, "organization", organizationId, "TimeSheetsData", u.id, "weeks");
          const snap = await getDocs(tsColRef);

          snap.docs.forEach(wkDoc => {
            const wkData = wkDoc.data();
            const entries = wkData.entries || [];
            entries.forEach((e: any) => {
              if (
                e.status === "pending" &&
                Array.isArray(e.managerIds) &&
                e.managerIds.includes(currentUser.id)
              ) {
                byUser[u.id] = byUser[u.id] || [];
                byUser[u.id].push(e);
              }
            });
          });
        }));

        setEntriesByUser(byUser);
      } catch (err) {
        console.error("Error fetching pending timesheet counts:", err);
      }
    };

    fetchPendingCounts();
  }, [organizationId, currentUser, users]);

  const pendingTimesheetCount = Object.values(entriesByUser).flat().length;

  return (
    <Flex direction="column" h="100vh" bgGradient={bgGradient} overflow="hidden">
      <Flex flex="1" minH="0">
        {/* Sidebar */}
        <Sidebar
          isSidebarOpen={isSidebarOpen}
          setSidebarOpen={setSidebarOpen}
          activeTab={activeTab}
          setActiveTab={handleSetActiveTab}
          cardBg={cardBg}
          onLogout={logout}
          unreadNotifications={unreadNotifications}
          isAdmin={canViewAdminModules}
          isManagerOrMD={canViewManagerModules}
          hasApprovalStatus={hasApprovalStatus}
          isEditor={isEditor}
          isViewer={isViewer}
          canViewSystemSettings={canViewSystemSettings}
          isOrgAdmin={isOrgAdmin}
          timesheetPendingCount={pendingTimesheetCount}
          orgName={orgName}
          isAdminView={isAdminView}
          setIsAdminView={handleSetIsAdminView}
          isLoading={isInitialLoad}
        />

        {/* Main Content */}
        <Box
          flex="1"
          minH="0"
          p={4}
          overflow={activeTab === "Approvals" || activeTab === "TimeSheet Approval" || activeTab === "Leave Approval" ? "hidden" : "auto"}
          marginLeft={isSidebarOpen ? "250px" : "80px"}
          position="relative"
          display="flex"
          flexDirection="column"
        >
          {/* Subscription Status Check - Only show when loading is complete and access is denied */}
          {!subscriptionLoading && subscriptionStatus !== null && !hasAccess && (
            <Box
              position="fixed"
              left="40%"
              top="30%"
              bg={cardBg}
              border="2px solid"
              borderColor={isDark ? "#B59143" : "#E8C16C"}
              borderRadius="lg"
              p={6}
              width={"90%"}
              maxW="500px"
              boxShadow="xl"
              zIndex={100}
            >
              <Text
                fontSize="lg"
                fontWeight="bold"
                color={isDark ? "#E8C16C" : "#B59143"}
                mb={2}
              >
                Subscription Required
              </Text>
              <Text fontSize="sm" color={textColor}>
                You need a subscription to access this feature. Please contact your administrator to activate your subscription.
              </Text>
            </Box>
          )}
          {/* Floating Search Bar */}
          {/* <Box
            position="fixed"
            top="20px"
            right="20px"
            zIndex={1000}
          >
            <InputGroup className="relative">
              <InputLeftElement pointerEvents="none">
                <div className="w-8 h-8 rounded-full bg-white/10 flex items-center justify-center">
                  <SearchIcon className="text-white/80 w-4 h-4" />
                </div>
              </InputLeftElement>
              <Input
                placeholder={`Search ${activeTab.toLowerCase()}...`}
                size="md"
                className="bg-white/10 backdrop-blur-sm text-white font-medium rounded-full border border-white/30 w-[340px] placeholder-white/70 focus:bg-white/20 focus:ring-2 focus:ring-white/50 focus:border-transparent transition-all duration-200 pl-12 shadow-lg"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </InputGroup>
          </Box> */}

          {isAdmin && (
            <>
              {activeTab === "Users" && (
                <>
                  {hasAccess ? (
                    <UserTable
                      isLoading={isLoading}
                      users={filteredUsers}
                      isAdmin={hasAdminActionAccess}
                      canAssignProjects={canAssignProjects}
                      cardBg={cardBg}
                      textColor={textColor}
                      handleOpenAssignProjects={handleOpenAssignProjects}
                      setEditingUser={setEditingUser}
                      setNewUser={setNewUser}
                      onUserModalOpen={onUserModalOpen}
                      handleDeleteUser={handleDeleteUser}
                      organizationId={organizationId}
                    />
                  ) : null}
                </>
              )}
            </>
          )}
          {activeTab === "Projects" && (
            hasAccess ? (
              <>
                <div className={`flex-shrink-0 flex justify-between items-center p-4 ${theme.headerGradient} rounded-md mb-4 border ${theme.border}`}>
                  {isDark && (
                    <>
                      <span className={theme.headerOverlayGlow} />
                      <span className={theme.headerOverlayTopLine} />
                      <span className={theme.headerOverlayBottomGlow} />
                      <span className={theme.headerOverlaySweep} />
                    </>
                  )}
                  <div className="flex flex-col space-y-1">
                    <span className={`text-2xl font-bold ${theme.text}`}>
                      Project Management
                    </span>
                    <span className={`text-xs ${theme.textMuted}`}>
                      Start by Adding a Project to Drive Enterprise Success
                    </span>
                  </div>

                  {canCreateProject && (
                    <button
                      onClick={onAddProjectModalOpen}
                      className={`flex items-center px-3 py-1.5 ${theme.primaryButton} rounded-full text-sm focus:outline-none`}
                    >
                      <IconWrapper icon={FaPlusCircle} className="mr-1" size={16} />
                      Add Project
                    </button>
                  )}
                </div>

                <Modal
                  isOpen={isAddProjectModalOpen}
                  onClose={onAddProjectModalClose}
                  size="md"
                  isCentered
                >
                  <ModalOverlay bg={isDark ? "blackAlpha.700" : "blackAlpha.500"} backdropFilter="blur(5px)" />
                  <ModalContent
                    borderRadius="lg"
                    p={5}
                    boxShadow="xl"
                    bg={isDark ? "#1A1C1F" : "white"}
                    border="1px solid"
                    borderColor={isDark ? "#2E2F33" : "#E5E7EB"}
                  >
                    <ModalHeader
                      color={isDark ? "#E8C16C" : textColor}
                      fontSize="lg"
                      fontWeight="bold"
                    >
                      Add Project
                    </ModalHeader>
                    <ModalCloseButton color={isDark ? "#C3C9D3" : textColor} />

                    <ModalBody>
                      <ProjectForm
                        isProjectSaving={isProjectSaving}
                        newProject={newProject}
                        setNewProject={setNewProject}
                        channelInputs={channelInputs}
                        handleAddChannelInput={handleAddChannelInput}
                        handleChannelInputChange={handleChannelInputChange}
                        handleRemoveChannelInput={handleRemoveChannelInput}
                        handleAddProject={handleAddProject}
                        textColor={textColor}
                        cardBg={cardBg}
                        isSidebarOpen={isSidebarOpen}
                      />
                    </ModalBody>
                  </ModalContent>
                </Modal>

                <div className={`w-full rounded-md border ${theme.border} ${theme.card}`}>
                  <div className={`flex justify-between items-center px-4 py-3 border-b ${theme.border} rounded-t-md flex-wrap`}>
                    <div className={`relative flex items-center max-w-sm w-full rounded-full ${theme.cardMuted} overflow-hidden`}>
                      <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                        <IconWrapper icon={FaSearch} className={`h-4 w-4 ${theme.textMuted}`} size={16} />
                      </div>
                      <input
                        type="text"
                        placeholder="Search projects..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        className={`${theme.searchInput} block w-full pl-10 pr-3 py-1.5 border rounded-full leading-5 focus:outline-none sm:text-sm`}
                      />
                    </div>
                    <span className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold mt-4 md:mt-0 ${isDark ? 'text-[#C3C9D3] border border-[#4A4D54]' : 'text-gray-600 border border-gray-300'}`}>
                      {filteredProjects.length} projects
                    </span>
                  </div>
                  <div className="p-4">
                    <ProjectTable
                      filteredProjects={filteredProjects}
                      users={users}
                      handleEditProject={handleEditProject}
                      confirmDelete={confirmDelete}
                      textColor={textColor}
                      cardBg={cardBg}
                      currentUser={currentUser}
                      canManageAccess={canManageProjectAccess}
                      handleOpenProjectAccess={handleOpenProjectAccess}
                    />
                  </div>
                </div>

                {canManageProjectAccess && organizationId && (
                  <ProjectAccessModal
                    isOpen={isProjectAccessOpen}
                    onClose={onProjectAccessClose}
                    organizationId={organizationId}
                    project={accessProject}
                    users={users}
                    currentUser={currentUser}
                    onSaved={refreshCurrentUserProjectAccess}
                  />
                )}
              </>
            ) : null
          )}
          {activeTab === "Tasks" && organizationId && (
            hasAccess ? (
              <GanttMain
                organizationId={organizationId}
                bg={cardBg}
                color={textColor}
                users={users}
                filteredprojects={filteredProjects}
                currentUser={currentUser}
                isSidebarOpen={isSidebarOpen}
              />
            ) : null
          )}

          {activeTab === "TimeSheets" && organizationId && (
            hasAccess ? (
              <Box flex="1" minH="0" display="flex" flexDirection="column">
                <UserPerformance
                  color={textColor}
                  bg={cardBg}
                  organizationId={organizationId}
                  users={filteredUsers}
                  currentUser={currentUser}
                />
              </Box>
            ) : null
          )}
          {activeTab === "Progress" && organizationId && (
            hasAccess ? (
              <ProjectPerformance
                color={textColor}
                bg={cardBg}
                organizationId={organizationId}
                projects={filteredProjects}
                users={users}
                isAdmin={hasManagerActionAccess}
                currentUser={currentUser}
              />
            ) : null
          )}

          {activeTab === "KPI-Metric" && organizationId && (
            hasAccess ? (
              <KpiMetricMain
                color={textColor}
                bg={cardBg}
                organizationId={organizationId}
                users={users}
                isAdmin={hasManagerActionAccess}
                currentUserId={currentUser?.id || ""}
                isOrgAdmin={isOrgAdmin}
              />
            ) : null
          )}

          {activeTab === "ManagerBooking" && organizationId && hasAccess && (
            <ManagerBooking users={users} currentOrgId={organizationId} />
          )}

          {activeTab === "SeatBooking" && organizationId && hasAccess && (
            <UserBooking currentOrgId={organizationId} />
          )}

          {activeTab === "Notifications" &&
            organizationId &&
            currentUser?.id && (
              hasAccess ? (
                <NotificationMain
                  color={textColor}
                  bg={cardBg}
                  organizationId={organizationId}
                  userId={currentUser.id} // ✅ Ensures logged-in user sees their notifications
                />
              ) : null
            )}

          {(isAdmin || isEditor) && (
            <>
              {activeTab === "Sentiment" && organizationId && (
                hasAccess ? (
                  <SentimentAnalysis
                    color={textColor}
                    bg={cardBg}
                    organizationId={organizationId}
                    projects={projects}
                    users={users}
                  />
                ) : null
              )}

              {activeTab === "Burn-Out" && organizationId && (
                hasAccess ? (
                  <BurnOutAnalysis
                    users={filteredUsers}
                    color={textColor}
                    bg={cardBg}
                    organizationId={organizationId}
                  />
                ) : null
              )}
            </>
          )}

          {activeTab === "profile" && organizationId && (
            hasAccess ? (
              <ProfileMenu
                currentUser={currentUser}
                bg={cardBg}
                textColor={textColor}
              />
            ) : null
          )}

          {activeTab === "LogPanel" && organizationId && (
            hasAccess ? (
              <CheckInMain
                currentUser={currentUser}
                bg={cardBg}
                textColor={textColor}
                organizationId={organizationId}
                setActiveTab={
                  handleSetActiveTab as React.Dispatch<React.SetStateAction<TabType>>
                }
              />
            ) : null
          )}

          {activeTab === "Approvals" && (
            canApproveTimesheet ? (
              <ApprovalsPage
                bg={cardBg}
                color={textColor}
                organizationId={organizationId}
                currentUserId={currentUser?.id || ""}
                users={users}
                setActiveTab={
                  handleSetActiveTab as React.Dispatch<React.SetStateAction<TabType>>
                }
              />
            ) : null
          )}

          {activeTab === "TimeSheet Approval" && (
            canApproveTimesheet ? (
              <TimeSheetApprovalPage
                bg={cardBg}
                color={textColor}
                organizationId={organizationId}
                currentUserId={currentUser?.id || ""}
                users={users}
                setActiveTab={
                  handleSetActiveTab as React.Dispatch<React.SetStateAction<TabType>>
                }
              />
            ) : null
          )}

          {activeTab === "Leave Approval" && (
            hasAccess ? (
              <LeaveApprovalPage
                organizationId={organizationId}
                currentUserId={currentUser?.id || ""}
                users={users}
                setActiveTab={
                  handleSetActiveTab as React.Dispatch<React.SetStateAction<TabType>>
                }
              />
            ) : null
          )}

          {canViewAdminModules && activeTab === "Alert" && (
            organizationId && hasAccess ? (
              <CheckInAlert organizationId={organizationId} users={users} currentUser={currentUser} />
            ) : null
          )}

          {activeTab === "Calendar" &&
            hasAccess &&
            (showCalendarDetails ? (
              <CheckInAlert
                organizationId={organizationId}
                users={users}
                initialUserId={currentUser?.id || undefined}
                onBackToCalendar={() => setShowCalendarDetails(false)}
                currentUser={currentUser}
              />
            ) : (
              <CalendarPage
                bg={cardBg}
                color={textColor}
                organizationId={organizationId}
                users={users}
                currentUser={currentUser}
                projects={projects}
                isAdmin={hasManagerActionAccess}
              />
            ))}

          {canViewAdminModules && activeTab === "WorkGroup" && organizationId && hasAccess && (
            <WorkGroup
              users={users}
              roles={roles}
              onUpdatePermission={handleUpdatePermission}
              onAddRole={handleAddRole}
              onDeleteRole={handleDeleteRole}
              onAssignRole={handleAssignRole}
              onUpdateRole={handleUpdateRole}
              onUpdateUserApprovalStatus={handleUpdateUserApprovalStatus}
              cardBg={cardBg}
              textColor={textColor}
              isLoading={isLoading}
              currentUserRole={currentUser?.role}
              currentUserPermissions={currentUser?.permissions}
            />
          )}

          {canViewAdminModules && activeTab === "Departments" && organizationId && hasAccess && (
            <Departments
              cardBg={cardBg}
              textColor={textColor}
              organizationId={organizationId}
            />
          )}

          {canViewAdminModules && activeTab === "Leave Management" && organizationId && hasAccess && (
            <LeaveManagement
              organizationId={organizationId}
              userId={currentUser?.id || ""}
              userName={`${currentUser?.firstName} ${currentUser?.lastName}`}
              users={users}
            />
          )}


          {activeTab === "Check-Ins" && organizationId && hasAccess && (
            <CheckInAlert
              organizationId={organizationId}
              users={users}
              initialUserId={currentUser?.id || undefined}
              hideBackButton={true}
              currentUser={currentUser}
              allowReasonEntry={true}
            />
          )}


          {activeTab === "Team Chats" && (
            <TeamChatsMain
              currentUser={currentUser}
              organizationId={organizationId}
              projects={projects}
              users={users}
              orgAdminId={orgAdminId}
            />
          )}

          {activeTab === "My Chats" && (
            <MyChatsMain
              currentUser={currentUser}
              organizationId={organizationId}
              users={users}
            />
          )}

          {activeTab === "Help" && (
            <Help />
          )}

          {activeTab === "Overview" && hasAccess && (
            <OverviewMain organizationId={organizationId} users={users} />
          )}

          {activeTab === "SystemLogs" && hasAccess && (
            <SystemLogs />
          )}

          {activeTab === "System Settings" && organizationId && canViewSystemSettings && hasAccess && (
            <SystemSettings
              currentUser={currentUser}
              organizationId={organizationId}
            />
          )}
        </Box>
      </Flex>

      <AlertDialog
        isOpen={isDeleteModalOpen}
        leastDestructiveRef={cancelRef as React.RefObject<HTMLElement>}
        onClose={onDeleteModalClose}
      >
        <AlertDialogOverlay bg={isDark ? "blackAlpha.700" : "blackAlpha.500"} />
        <AlertDialogContent
          borderRadius="lg"
          boxShadow="2xl"
          bg={isDark ? "#1A1C1F" : "white"}
          p={4}
          color={isDark ? "white" : "gray.800"}
          borderWidth="1px"
          borderColor={isDark ? "#2E2F33" : "gray.200"}
        >
          <AlertDialogHeader
            fontSize="xl"
            fontWeight="bold"
            textAlign="center"
            color={isDark ? "#E8C16C" : "red.600"}
            borderBottomWidth="1px"
            borderColor={isDark ? "#2E2F33" : "gray.200"}
            pb={2}
          >
            Confirm Deletion
          </AlertDialogHeader>

          <AlertDialogBody
            py={4}
            textAlign="center"
            fontSize="md"
            color={isDark ? "#C3C9D3" : "gray.600"}
          >
            Are you sure you want to delete this project? This action cannot be
            undone and might affect other data.
          </AlertDialogBody>

          <AlertDialogFooter justifyContent="center" pt={4}>
            <Button
              ref={cancelRef}
              onClick={onDeleteModalClose}
              px={6}
              mr={3}
              variant="solid"
              bg={isDark ? "#2A3441" : "gray.100"}
              color={isDark ? "white" : "gray.700"}
              _hover={{ bg: isDark ? "#3A4553" : "gray.200" }}
            >
              Cancel
            </Button>
            <Button
              onClick={handleConfirmDelete}
              px={6}
              colorScheme="red"
              boxShadow="sm"
              _hover={{ boxShadow: "md" }}
              isDisabled={
                !selectedProject ||
                !canDeleteProject(
                  projects.find((p) => p.id === selectedProject) || undefined
                )
              }
            >
              Delete
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>

      <Modal
        isOpen={isProjectModalOpen}
        onClose={onProjectModalClose}
        closeOnOverlayClick={false}
        closeOnEsc={true}
      >
        <ModalOverlay bg={isDark ? "blackAlpha.700" : "blackAlpha.500"} />
        <ModalContent
          borderRadius="lg"
          boxShadow="xl"
          bg={isDark ? "#1A1C1F" : "white"}
          borderWidth="1px"
          borderColor={isDark ? "#2E2F33" : "#E5E7EB"}
        >
          <ModalHeader color={isDark ? "#E8C16C" : textColor}>
            {editingProject ? "Edit Project" : "Add Project"}
          </ModalHeader>
          <ModalCloseButton color={isDark ? "#C3C9D3" : textColor} />
          <ModalBody color={textColor}>
            {editingProject && (
              <EditProjectForm
                projectName={editProjectName}
                setProjectName={setEditProjectName}
                channelInputs={editChannelInputs}
                setChannelInputs={setEditChannelInputs}
                handleUpdateProject={handleUpdateProject}
                isUpdating={isProjectUpdating}
                textColor={textColor}
                cardBg={cardBg}
                isSidebarOpen={isSidebarOpen}
                handleCancel={onProjectModalClose}
              />
            )}
          </ModalBody>
        </ModalContent>
      </Modal>

      <AssignProjectsModal
        bg={cardBg}
        color={textColor}
        isOpen={isAssignProjectsOpen}
        onClose={onAssignProjectsClose}
        userId={selectedUser?.id || ""}
        assignedProjects={selectedUser?.assignedProjects || []}
        allProjects={projects}
        organizationId={organizationId}
        refreshUsers={fetchUsers}
        refreshProjects={fetchProjects}
        currentUser={currentUser || { role: "user" }}
      />

      <AddUserModal
        isUserSaving={isUserSaving}
        bg={cardBg}
        color={textColor}
        isOpen={isUserModalOpen}
        onClose={onUserModalClose}
        newUser={newUser}
        setNewUser={setNewUser}
        editingUser={editingUser}
        setEditingUser={setEditingUser}
        handleAddOrUpdateUser={handleAddOrUpdateUser}
        organizationId={organizationId} // Passed prop
      />
    </Flex>
  );
};

export default Dashboard;
